import React, { createContext, useContext } from 'react';
import { useLocation } from 'react-router';
import { AnimatePresence } from "framer-motion";
import { useEffect,useState,useRef  } from 'react';
import { useNavigate } from 'react-router-dom';
import { Capacitor } from '@capacitor/core';

// Utils.js
class Utils  {

    static RATE_APP_FIRST_SHOW_DELAY_MS = 7 * 24 * 60 * 60 * 1000; // legkorábban az első megnyitást követő 7. napon jelenhet meg
    static RATE_APP_DISMISS_COOLDOWN_MS = 14 * 24 * 60 * 60 * 1000; // X-szel bezárás után 14 napig nem jelenhet meg újra
    static RATE_APP_MIN_DELAY_AFTER_OPEN_MS = 60 * 1000; // az app megnyitása/előtérbe kerülése után legalább ennyit várjon, mielőtt feldobná
    static RATE_APP_ANDROID_PACKAGE = 'dorko.webshop';
    static RATE_APP_IOS_APP_ID = '6502993827';

    // az első app-megnyitás időpontját eltárolja (egyszer), és ezt adja vissza minden további híváskor
    static getRateAppFirstOpenAt() {
        let firstOpenAt = localStorage.getItem('rate_app_first_open_at');

        if (!firstOpenAt) {
            firstOpenAt = Date.now().toString();
            localStorage.setItem('rate_app_first_open_at', firstOpenAt);
        }

        return parseInt(firstOpenAt, 10);
    }

    // ellenőrzi, hogy meg kell-e jeleníteni az alkalmazás-értékelő popupot: natív platform, még nem értékelt,
    // eltelt már 7 nap az első megnyitás óta, és nincs aktív (X-zárás utáni 14 napos) cooldown
    static checkRateAppPopup() {
        //if (!Capacitor.isNativePlatform()) return;
        if (localStorage.getItem('rate_app_rated') === '1') return;

        const firstOpenAt = this.getRateAppFirstOpenAt();
        if (Date.now() - firstOpenAt < this.RATE_APP_FIRST_SHOW_DELAY_MS) return;

        const cooldown = this.localSorageGetWithExpiry('rate_app_last_shown');
        if (cooldown !== null) return;
        
        // ne egyből az app megnyitása után dobja fel
        setTimeout(() => {
            if (window.modals?.PopupRateAppRef?.current) {
                window.modals.PopupRateAppRef.current.show();
            }
        }, this.RATE_APP_MIN_DELAY_AFTER_OPEN_MS);
    }

    // popup bezárásakor (X gomb vagy vissza gomb): 14 napos cooldown, mielőtt újra megkísérelné a megjelenítést
    static postponeRateAppPopup() {
        this.localSorageSetWithExpiry('rate_app_last_shown', Date.now(), this.RATE_APP_DISMISS_COOLDOWN_MS);
    }

    // platformnak megfelelő store oldalra irányít át értékeléshez, és véglegesen elrejti a popupot.
    // natív URI sémával (market:// / itms-apps://) nyitjuk, hogy közvetlenül a Play Store / App Store
    // alkalmazás induljon el, ne villanjon fel közben egy in-app böngésző (Custom Tabs / SFSafariViewController).
    static async openStoreForRating() {
        if (Capacitor.getPlatform() === 'android') {
            window.location.href = `market://details?id=${this.RATE_APP_ANDROID_PACKAGE}`;
        } else if (Capacitor.getPlatform() === 'ios') {
            window.location.href = `itms-apps://itunes.apple.com/app/id${this.RATE_APP_IOS_APP_ID}?action=write-review`;
        }

        localStorage.setItem('rate_app_rated', '1');
    }

    static get_path_from_url(){

        const location = window.location.href.replace(process.env.REACT_APP_PUBLIC_URL,'');
        const location_array = location.split('/');

        if(location_array.length>0)
        {
            return location_array[0];
        }
        else
        {
            return '';
        }

    }

    /**
     * Meghívja az API végpontot, úgy hogy a linkből előbb kiveszi az első tagot (ha van), mert az a react route megnevezése.
     */
    static async get_server_data(path = '', query_string = {}, post_data = {}) {

        let result = {};

        if (parseInt(process.env.REACT_APP_USE_DEMO_SERVER_DATA) === 1 && query_string.ajax_event)
        {
            var data = require('./json/ajax/'+query_string.ajax_event+'.json');

            return data;
        }
        else {
            const location = path;
            const location_array = location.split('/');
            
            
            const remember_hash = this.localSorageGetWithExpiry('remember_hash_hu');

            if(remember_hash){
                if (query_string.ajax_event == 'get_initial_data' || query_string.ajax_event == 'get_settings')
                {
                    query_string['device_id'] = remember_hash;
                }
            }
            

            const target_path = location_array
                .filter((value, index) => index > 1)
                .join('/') + ((Object.keys(query_string).length>0) ? '?' + this.objectToQueryString(query_string) : '');

            const options = {};

            if (Object.keys(post_data).length>0) {
                options.method = "POST";
                options.body = this.objectToQueryString(post_data);
                options.headers = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
            }

            result = await this.xhr_fetch(process.env.REACT_APP_API_SERVER_URL + target_path, options).then((res) => { 
                if(res && res.dialog_message && window.AppRef && window.AppRef.current){
                    window.AppRef.current.set_dialog_message(res.dialog_message);
                }
                return res; 
            })
        
            return result;
        }
    }

    // ha egy a tag-nek üres a data-type attribútuma akkor le kell kérdezni a szervertől a link adatait,
    // és a válasz alapján lehet tovább navigálni
    static async get_url_data(url) {
        let result = {};

        if (url !== null) {
            url = url.replace(window.location.origin + '/', '');

            if (!!url && !!url.length) {

                const options = {};
                options.method = "GET";
                options.mode = "cors";
                options.headers = { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' };
        
                result = await Utils.xhr_fetch(process.env.REACT_APP_API_SERVER_URL + '?ajax_event=get_url_data&url='+encodeURIComponent(url)+'&APICACHE=false', options).then((res) => { return res; })
            }
        }

        return result;
    }

    static setCookie(cname, cvalue, exdays) {
        var expires = '';

        if(exdays)
        {
            const d = new Date();
            d.setTime(d.getTime() + (exdays*24*60*60*1000));
            expires = "expires="+ d.toUTCString();
        }

        document.cookie = cname + "=" + cvalue + ";" + expires + ";domain=" + process.env.REACT_APP_COOKIE_DOMAIN + ";path=/";
      }

    static xhr_fetch(url, options = {}) {

        var default_options = {
            mode: 'cors',
            method: 'GET',
            credentials: 'include'
        };

        options = Object.assign(default_options, options);
     
        if(!options.headers) {
            options.headers = {};

        }

        return window.fetch(url, options)
            .then(res => {
                return res.json();
            })
            .then((res) => {
                return res;
            })
            .catch((msg) => {

            });
    }


    static objectToQueryString(obj) {
        const keys = Object.keys(obj);
        const keyValuePairs = keys.map(key => {
            return encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]);
        });
        return keyValuePairs.join('&');
    }

    static localSorageSetWithExpiry(key, value, ttl) {
        const now = new Date()

        const item = {
            value: value,
            expiry: now.getTime() + ttl,
        }
        
        localStorage.setItem(key, JSON.stringify(item))
    }

    static localSorageGetWithExpiry(key) {
        const itemStr = localStorage.getItem(key)

        // if the item doesn't exist, return null
        if (!itemStr) {
            return null
        }

        const item = JSON.parse(itemStr)
        const now = new Date()
        
        // compare the expiry time of the item with the current time
        if (now.getTime() > item.expiry) {
            // If the item is expired, delete the item from storage
            // and return null
            localStorage.removeItem(key)
            return null
        }
        
        return item.value
    }

    static add_product_to_shopping_cart(product_id,pc,item_attributes){

        pc = (pc ? pc : 1);
        item_attributes = (item_attributes ? item_attributes : '');

        const post_data = {
            'ajax_event':'get_shoppingcart',
            'ajax_add_to_cart':1,
            'pc_product': pc,
            'sql_id_product': product_id,
            'item_attributes_product': item_attributes,
            'webshop_event': 'add_shopping_cart'
        };

        this.get_update_shopping_cart(post_data);
    }

    static shopping_cart_modify(product,order_id,coupon_code,loyalti_data)
    {
        let post_data = {};

        post_data['shopping_cart_pc_'+product.orders_items_id+'_x'] = product.pc;
        post_data['sql_id_orders_items_'+product.orders_items_id+'_x'] = product.orders_items_id;
        post_data['sql_id_orders_'+product.orders_items_id+'_x'] = order_id;
        post_data['shopping_cart_modify'] = 'shopping_cart_modify_'+product.orders_items_id+'_x';

        if(coupon_code){
            post_data['select_coupon'] = coupon_code;
        }

        if(loyalti_data){
            post_data = this.shopping_cart_set_loyalti_codes(post_data,loyalti_data);
        }


        this.get_update_shopping_cart(post_data);
    }

    static shopping_cart_delete(product,order_id,coupon_code,loyalti_data)
    {
        let post_data = {};

        post_data['shopping_cart_pc_'+product.orders_items_id+'_x'] = product.pc;
        post_data['sql_id_orders_items_'+product.orders_items_id+'_x'] = product.orders_items_id;
        post_data['sql_id_orders_'+product.orders_items_id+'_x'] = order_id;
        post_data['shopping_cart_delete'] = 'shopping_cart_delete_'+product.orders_items_id+'_x';

        if(coupon_code){
            post_data['select_coupon'] = coupon_code;
        }

        if(loyalti_data){
            post_data = this.shopping_cart_set_loyalti_codes(post_data,loyalti_data);
        }


        this.get_update_shopping_cart(post_data);
    }

    static shopping_cart_set_coupon(params)
    {
        this.get_update_shopping_cart(params);
    }

    static shopping_cart_set_loyalti_codes(post_data,loyalti_data)
    {
        const _post_data = post_data ? post_data : {};

        if(loyalti_data?.loyalti_code)
        {
            _post_data['select_ugyfelkartya'] = loyalti_data.loyalti_code;
        }
        
        if(loyalti_data?.loyalti_gross)
        {
            _post_data['select_ugyfelkartya_gross'] = loyalti_data.loyalti_gross;
        }

        if(loyalti_data?.loyalti_coupon_id)
        {
            _post_data['select_ugyfelkartya_coupon_id'] = loyalti_data.loyalti_coupon_id;
        } 

         if(loyalti_data?.coupon_code)
        {
            _post_data['select_coupon'] = loyalti_data.coupon_code;
        }
            
        return _post_data;
    }
    

    static get_update_shopping_cart(post_data,initial){

        const post_data_ = (post_data) ? post_data : {};

        post_data_['ajax_event'] = 'get_shoppingcart';

        this.get_server_data('',{},post_data_).then((resp) => {
            // ha üres a kosár akkor object helyett false jön vissza
            if(typeof resp.shopping_cart !== 'undefined'){
                window.AppRef.current.get_update_shopping_cart(resp.shopping_cart,initial);
            }

            //ha módosít a kosáron újra kell inicializálni a checkoutot 
            if(window.modals.CheckoutSummaryRef?.current){
                window.modals.CheckoutSummaryRef.current.checkoutInitDone = false;
            }
        });

    }
}


function NavigateTo({toURL,prefix}) {

    const navigate = useNavigate();

    useEffect(() => {
        if(prefix){
        toURL = prefix+'/'+toURL;
        }
        navigate(toURL)
    },[]);


    return <></>;
}

function AnimatePresenceWrapper({ children }) {
    return <AnimatePresence>{children}</AnimatePresence>;
}

const ElementVisibilityChecker = (props) => {

    const [isVisible, setIsVisible] = useState(false);
    const targetRef = useRef(null);
    const children = (props.children) ? props.children : null;
  
    useEffect(() => {
      const observer = new IntersectionObserver(
        ([entry]) => {
          setIsVisible(entry.isIntersecting);
          if(entry.isIntersecting && typeof props.onVisible == 'function'){
            props.onVisible(children);
          }
        },
        {
          root: null, // viewport
          rootMargin: '0px', // no margin
          threshold: 0.5, // 50% of target visible
        }
      );
  
      if (targetRef.current) {
        observer.observe(targetRef.current);
      }
  
      // Clean up the observer
      return () => {
        if (targetRef.current) {
          observer.unobserve(targetRef.current);
        }
      };
    }, []);
  
    return (
        <div ref={targetRef}>
            {children}
        </div>
    );
  };

  //ez az IOS css vh bug miatt kell
  let vh = window.innerHeight;
  document.documentElement.style.setProperty('--vh', `${vh}px`);

  window.addEventListener("resize", (event) => {
    let vh = window.innerHeight;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  });

export {Utils, AnimatePresenceWrapper, NavigateTo, ElementVisibilityChecker };